export const SET_LOGIN_USER_IMAGE = 'app/Login/SET_LOGIN_USER_IMAGE';